interface Props {
  countdown: number;
  onStayLoggedIn: () => void;
}

const formatCountdown = (seconds: number): string => {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
};

const InactivityWarningModal = ({ countdown, onStayLoggedIn }: Props) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-sm w-full mx-4 text-center">
        <h2 className="text-lg font-semibold text-neutral-800 mb-2">Still there?</h2>
        <p className="text-sm text-neutral-500 mb-1">
          You will be logged out due to inactivity in
        </p>
        <p className="text-3xl font-mono font-bold text-blue-500 my-4">
          {formatCountdown(countdown)}
        </p>
        <button
          onClick={onStayLoggedIn}
          className="w-full bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 rounded-md transition-colors"
        >
          Stay logged in
        </button>
      </div>
    </div>
  );
};

export default InactivityWarningModal;
